<template>
  <div class="esdropdown" @mouseover="isShow = true" @mouseleave="isShow = false" v-bind:class="{hover: isShow}">
    <div v-on:click="slotClick" v-bind:class="['slot'+guid, {'active': isShow}]">
      <slot></slot>
    </div>
    <transition name="fade">
      <div v-on:click="isShow = false" class="espop" v-show="isShow" v-bind:class="'pop'+guid" :style="popStyle">
        <slot name="content"></slot>
          <div class="espoptip" v-bind:class="'poptip'+guid"></div>
          <div class="espoptip-cover" v-bind:class="'poptip-cover'+guid"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Es-Dropdown',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      default: 'click'
    },
    popStyle: {
      type: Object,
      default: function () { return {} }
    },
    shadowStyle: {
      type: Object,
      default: function () { return {} }
    },
    pushUp: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'left' // left|center|right
    },
    shadowLight: {
      type: Boolean,
      default: false
    },
    shadowActive: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      guid: 0,
      isShow: false,
      calcPopStyle: {}
    }
  },
  mounted () {
    this.guid = Math.floor(Math.random() * 100000000000000)
    this.isShow = this.value
  },
  methods: {
    slotClick: function () {
      if (this.trigger === 'click') this.isShow = !this.isShow
    },
    getElement: function (text) {
      if (text.indexOf('#') === 0) {
        return document.getElementById(text.replace('#', ''))
      } else if (text.indexOf('.') === 0) {
        return document.getElementsByClassName(text.replace('.', ''))[0]
      } else {
        return null
      }
    },
    calcPosition: function () {
      var pop = document.getElementsByClassName('pop' + this.guid)[0]
      var poptip = document.getElementsByClassName('poptip' + this.guid)[0]
      var poptipCover = document.getElementsByClassName('poptip-cover' + this.guid)[0]
      var slot = document.getElementsByClassName('slot' + this.guid)[0]
      var left = 0
      switch (this.position) {
        case 'left':
          pop.style.setProperty('right', null)
          pop.style.setProperty('left', '0px')
          left = (slot.offsetLeft - pop.offsetLeft) + (slot.offsetWidth / 2) - 10
          poptip.style.left = left + 'px'
          poptipCover.style.left = (slot.offsetLeft - pop.offsetLeft) + 'px'
          break
        case 'center':
          pop.style.setProperty('right', null)
          pop.style.setProperty('left', '-' + (pop.offsetWidth - slot.offsetWidth) / 2 + 'px')
          left = (pop.offsetWidth / 2) - 10
          poptip.style.left = left + 'px'
          poptipCover.style.left = (slot.offsetLeft - pop.offsetLeft) + 'px'
          break
        case 'right':
          pop.style.setProperty('left', null)
          pop.style.setProperty('right', '0px')
          left = (slot.offsetLeft - pop.offsetLeft) + (slot.offsetWidth / 2) - 10
          poptip.style.left = left + 'px'
          poptipCover.style.left = (slot.offsetLeft - pop.offsetLeft) + 'px'
          break
      }
    }
  },
  watch: {
    value: function () {
      this.isShow = this.value
    },
    isShow: function () {
      var self = this
      this.$emit('input', this.isShow)
      if (self.isShow) {
        setTimeout(function () {
          self.calcPosition()
        }, 50)
      }
      if (this.pushUp.length === 0) return
      var items = this.pushUp.split('|')
      items.forEach(function (item) {
        var element = self.getElement(item)
        if (element != null) {
          if (self.isShow) {
            element.style.zIndex = '102'
            // element.style.position = 'relative'
          } else {
            element.style.zIndex = null
            // element.style.position = null
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.esdropdown {
  position: relative;
}
.espoptip-cover {
  width: 200px;
  position: absolute;
  bottom: 100%;
  height: 100px;
}
.espop {
  display: none;
  position: absolute;
  z-index: 105;
  background-color: #fff;
  margin-top: 15px;
  background-color: #ffffff;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -webkit-box-shadow: 0 8px 16px 0 rgba(20, 94, 151, 0.3);
  -moz-box-shadow: 0 8px 16px 0 rgba(20, 94, 151, 0.3);
  box-shadow: 0 8px 16px 0 rgba(20, 94, 151, 0.3);
}
.espoptip {
    position: absolute;
    bottom: 100%;
    left: 10px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent var(--text-color4) transparent;
}
.shadow {
  display: none;
  position: fixed;
  width: 100%;
  height: calc(100vh);
  top: 0;
  left: 0;
  z-index: 100;
  transition: opacity .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  -webkit-transition: .5s ease-in-out;
}
.shadow.light {
  opacity: 0;
  background-color: #f7fdff;
}
.shadow.dark {
  opacity: 0;
  background-color: #004894;
}
/*.esdropdown.hover .espop, .esdropdown.hover .shadow {
  display: block;
}*/
.esdropdown.hover .espop {
  display: block;
}
.esdropdown.hover .shadow.light{
  opacity: 0.7;
  display: block;
}
.esdropdown.hover .shadow.dark {
  opacity: 0.3;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/shared/components/es-dropdown-hover.vue